import * as React from 'react';

function SvgMenu(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 17.93a.93.93 0 01.93-.93h18.14a.93.93 0 010 1.86H2.93a.93.93 0 01-.93-.93zM2 11.93a.93.93 0 01.93-.93h18.14a.93.93 0 010 1.86H2.93a.93.93 0 01-.93-.93zM2 5.93A.93.93 0 012.93 5h18.14a.93.93 0 010 1.86H2.93A.93.93 0 012 5.93z", clipRule: "evenodd" })));
}

export default SvgMenu;
